interface ICurlyBracesBinding {
    to: string,
    value: string,
    fn: string
}

/**
 * Basic String
 *
 * Enables chaning events, output must be called, else will return a chain
 *
 *
 */
export default class Strings {


    private _curlyBracesPattern = /{([^}]+)}/g;


    /**
     * Initialized the object with the source string to work with.
     */
    constructor(str: string) {
        this._string = str || '';
    }

    _string: string;



    /**
     * Make a string's first character uppercase
     * @see: http://php.net/manual/en/function.ucfirst.php
     */
    ucFirst() : string {
        return this._string.charAt(0).toUpperCase() + this._string.slice(1);
    }

    getCurlyBracesBinding(): Array<ICurlyBracesBinding> {
        let found: Array<ICurlyBracesBinding> = []; // an array to collect the strings that are found

        let currentMatch = this._curlyBracesPattern.exec(this._string);
        while (currentMatch) {
            found.push(this._getBindingMethod(currentMatch[1]));
            currentMatch = this._curlyBracesPattern.exec(this._string)
        }

        return found;
    }

    private _getBindingMethod(bindExpression: string) : ICurlyBracesBinding  {
        let bindMap = {
            to: bindExpression,
            value: '',
            fn: ''
        };

        let bindRelatedMethod = bindExpression.split('|');
        if (2 === bindRelatedMethod.length) {
            bindMap.value = bindRelatedMethod[0].trim();
            bindMap.fn = bindRelatedMethod[1].trim();
        }

        return bindMap;
    }


    /**
     * @description - Insert char at a specific position in the string.
     */
    insertAt(index: number, stringToInjectT: string, stringToInject: string) {
        return stringToInjectT.substr(0, index) + stringToInject + stringToInjectT.substr(index);
    }

    /**
     *
     * @returns {string}
     */
    stripslashes(): string {
        return (this._string + '')
            .replace(/\\(.?)/g, function (s, n1) {
                switch (n1) {
                    case '\\':
                        return '\\'
                    case '0':
                        return '\u0000'
                    case '':
                        return ''
                    default:
                        return n1
                }
            });
    }
    replaceAll(from: string, to: string)
    {
       return this._string.replace(new RegExp(to, 'g'), from);
    }

    getString() :string {
        return this._string;
    }

    setString(str): void {
        this._string = str;
    }

    /**
     * @description - Determines if a value is a empty string.
     */
    isEmpty(): boolean {
        return this._string.length === 0 || !this._string.trim();
    }


    /**
     *
     * @param partialString
     */
    startsWith(partialString) {
        if (!String.prototype.startsWith) {
            // eslint-disable-next-line
            String.prototype.startsWith = function (searchString, position) {
                position = position || 0;
                return this.substr(position, searchString.length) === searchString;
            };
        }

        return this._string.startsWith(partialString);
    }

    injectIntoCurly(bindingParams: object): string {
        if (bindingParams === undefined || bindingParams === null) {
            return this._string;
        }
        Object
            .keys(bindingParams)
            .forEach((bindTo) => {
                let tokens = this._string.split('{' + bindTo + '}');
                this._string = tokens.join(bindingParams[bindTo]);
            });

        return this._string;
    }
}
